const placeholderHref = "https://via.placeholder.com/267?text=Missing+thumbnail";
const imageSketchUrl = "/images/default-collection-sketch.png";

export const createImageSrc = (text: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");

    canvas.width = 220;
    canvas.height = 120;

    const context = canvas.getContext("2d");

    if (context === null) {
      return placeholderHref;
    }

    const image = new Image();

    image.onload = () => {
      const hrefSrc = createDefaultThumb(context, canvas, image, text);

      resolve(hrefSrc);
    };

    image.onerror = () => {
      const hrefSrc = createDefaultThumb(context, canvas, null, text);
      resolve(hrefSrc);
    };

    image.src = imageSketchUrl;
  });
};

const createDefaultThumb = (
  context: CanvasRenderingContext2D,
  canvas: HTMLCanvasElement,
  image: HTMLImageElement | null,
  text: string
): string => {
  context.fillStyle = "#131315";
  context.fillRect(0, 0, canvas.width, canvas.height);

  // Place graphic in the top right corner
  if (image) {
    context.drawImage(image, canvas.width - image.width - 15, 15);
  }

  // Add collection id
  context.fillStyle = "white";
  context.font = "12px Arial";
  const textX = 10;
  const textY = canvas.height - 15;
  const textWidth = context.measureText(text).width;
  context.fillText(text, textX, textY);

  // Draw a line under the text
  const underlineY = textY + 5;
  context.strokeStyle = "white";
  context.lineWidth = 2;
  context.beginPath();
  context.moveTo(textX, underlineY);
  context.lineTo(textX + textWidth, underlineY);
  context.stroke();

  return canvas.toDataURL("image/png");
};
